import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    selectedItem: '',
}

const logoutSlice = createSlice({
    name: 'logout',
    initialState,
    reducers: {
        setSelectedItem: (state, action) => {
            state.selectedItem = action.payload
        },
    },
})

export const { setSelectedItem } = logoutSlice.actions
export default logoutSlice.reducer
